import { END_POINTS, REQUEST_TYPE } from "../lib/variables";
import Api from "./index";

const createOrder = (payload) => {
  return Api(END_POINTS.createOrder, payload, REQUEST_TYPE.POST);
};
const getUserOrders = (id, query) => {
  return Api(
    `${END_POINTS.getUserOrders}/${id}?orderId=${query.orderId}`,
    null,
    REQUEST_TYPE.GET
  );
};

const getOrderDetail = (id) => {
  return Api(`${END_POINTS.getOrderDetail}/${id}`, null, REQUEST_TYPE.GET);
};

const updateOrderStatus = (id, params) => {
  return Api(`${END_POINTS.updateOrderStatus}/${id}`, params, REQUEST_TYPE.PUT);
};

const createEcomPaymentIntent = (payload) => {
  return Api(END_POINTS.createEcomPaymentIntent, payload, REQUEST_TYPE.POST);
};

export {
  createOrder,
  getUserOrders,
  getOrderDetail,
  updateOrderStatus,
  createEcomPaymentIntent,
};
